/**
 * @typedef  SubcategoriesContent
 * @property {string} title
 * @property {string} text
 * @property {{ alt: string, url: string, mobileUrl: string}} image
 * @property {CheckBoxOrRadioOption[]} subcategories
 */

/**
 * @typedef  CheckBoxOrRadioOption
 * @property {string} id
 * @property {string} label
 * @property {string} value
 * @property {boolean} checked
 * @property {boolean} disabled
 * @property {SubcategoriesContent} subcategoriesContent
 */

/**
 * @typedef  FilterRadio
 * @property {string} id
 * @property {string} value
 * @property {boolean} checked
 */

/**
 * @typedef  Filter
 * @property {string} id
 * @property {string} type
 * @property {string} label
 * @property {CheckBoxOrRadioOption[]} options
 * @property {FilterRadio} [radio]
 * @property {string} [advancedFiltersId]
 */

/**
 * @typedef  SelectOption
 * @property {string} value
 * @property {string} label
 */

/**
 * @typedef  Select
 * @property {string} id
 * @property {string} type
 * @property {string} label
 * @property {string | null} value
 * @property {boolean} disabled
 * @property {boolean} readonly
 * @property {string} placeholder
 * @property {SelectOption[]} options
 */

/**
 * @typedef  AdvancedFilter
 * @property {string} id
 * @property {Select[]} items
 */

/**
 * @typedef  Pagination
 * @property {number} rowsCount
 * @property {number} rowsOnPage
 * @property {number} pagesCount
 * @property {number} currentPage
 */

/**
 * @typedef  VideoCard
 * @property {string} id
 * @property {string} videoId
 * @property {string} title
 * @property {string} url
 * @property {string} thumbnailAlt
 * @property {string} description
 * @property {number} filesCount
 * @property {string} filesTitle
 * @property {string} date
 * @property {string} dateTitle
 * @property {string} estimate
 * @property {string} language
 * @property {string} buttonTitle
 * @property {{id: string, title: string, bgColor: string, color: string}[]} badges
 */

/**
 * @typedef  DocumentCard
 * @property {string} id
 * @property {string} title
 * @property {string} url
 * @property {boolean} blocked
 * @property {string} size
 * @property {string} blockedTitle
 * @property {string} downloadTitle
 */

/**
 * @typedef  DocumentsListingGroup
 * @property {string} id
 * @property {string} title
 * @property {string} category
 * @property {boolean} showAll
 * @property {number} itemsAmount
 * @property {DocumentCard[]} items
 */

/**
 * @typedef  NewsCard
 * @property {string} id
 * @property {string} title
 * @property {string} url
 * @property {string} category
 * @property {string} date
 * @property {string} dateTitle
 * @property {string} buttonTitle
 * @property {{url: string, alt: string}} image
 */

/**
 * @typedef  LocationCard
 * @property {string} id
 * @property {string} title
 * @property {string} url
 * @property {boolean} [dark]
 * @property {{url: string, alt: string}} image
 */

/**
 * @typedef  TradeShowCard
 * @property {string} id
 * @property {string} title
 * @property {string} date
 * @property {string} description
 * @property {{url: string, alt: string}} image
 * @property {string} info
 * @property {string} location
 * @property {{title: string, url: string, target: string, disabled: boolean}} link
 * @property {{title: string, email: string, disabled: boolean}} appointmentButton
 */

/**
 * @typedef State
 * @type {Object}
 * @property {Filter[]} filters
 * @property {AdvancedFilter[]} advancedFilters
 * @property {Array} items
 * @property {string} searchValue
 * @property {string} selectedSorting
 * @property {Pagination} pagination
 * @property {boolean} isLoading
 * @property {boolean} isLoadingMore
 */

exports.unused = {};
